import * as React from 'react';

import { ResponsiveBackgroundContainer } from '@shopee-user/shared-customization-ui';
import { useBackgroundColor } from '@shopee-user/background-color-container';
import { Theme } from '@shopee-user/business-customization-logic';
import { useResponsiveLayout, Layout } from '@shopee-user/layout-responsive';

import {
  getDefaultAuthDesktopBackgroundImage,
  getAuthDesktopBackgroundImageSet,
} from '../../utils/backgroundImage';
import { Feature } from '@shopee-user/feature-toggle';
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';

import commonStyles from '../common.styles.scss';

type Props = {
  className?: string;
  children: React.ReactNode;
};

// For businesses without background image, just use responsive container.
// Main difference is that the main content will be centered
export default function AuthBackgroundContainer(props: Props): JSX.Element {
  const isSpxOrangeBackgroundUiEnabled = isFeatureEnabled(
    Feature.SPXOrangeBackgroundUI,
    false
  );

  useBackgroundColor({
    desktop: Theme.ColorBackgroundWithLogo,
  });

  const { layout } = useResponsiveLayout();

  React.useLayoutEffect(() => {
    if (isSpxOrangeBackgroundUiEnabled && layout === Layout.Mobile) {
      document.body?.classList.add(`${commonStyles.bodyBackground}`);
    }

    return () => {
      if (isSpxOrangeBackgroundUiEnabled && layout === Layout.Mobile) {
        document.body?.classList.remove(`${commonStyles.bodyBackground}`);
      }
    };
  }, [layout]);

  return (
    <ResponsiveBackgroundContainer
      {...props}
      imageUrl={getDefaultAuthDesktopBackgroundImage()}
      imageUrlSet={getAuthDesktopBackgroundImageSet()}
    />
  );
}
